export default "__VITE_ASSET__DWLoyRhY__"